import React, { Fragment, useEffect,useContext, useState } from 'react';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import CountUp from 'react-countup';
import { Breadcrumbs, H5, H6 } from '../../../AbstractElements';
import EarnHistoryTable from './EarnHistoryTable';
import TransferModal from './TransferModal';
import { getEarnHistoryAPI } from '../../../Library/apis';
import { COLORS } from '../../../Library/theme';
import UserContext from '../../../_helper/User';

const EarnInterest = () => {
    const { userWalletInfo } = useContext(UserContext);
    const currentInterest = userWalletInfo.interest;
    
    const [data, setData] = useState([]);
    const [balance, setBalance] = useState(0);
    const [taxLiability, setTaxLiability] = useState(0); // New: Tracking Company Tax
    const [isLoading, setIsLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [modal, setModal] = useState(false);

    const LIMIT = 20;
    const toggle = () => setModal(!modal);

    const fetchHistory = (page = 1) => {
        setIsLoading(true);
        getEarnHistoryAPI(page, LIMIT)
            .then(res => {
                if (res.status === 'Ok') {
                    setData(res.body || []);
                    setBalance(res.commissionBalance || 0);
                    setTaxLiability(res.estimatedTax || 0); // Assuming API update
                    setTotalRows(res.pagination?.total || 0);
                    setCurrentPage(page);
                }
            })
            .catch(() => setData([]))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        fetchHistory(1);
    }, []);

    return (
        <Fragment>
            <Breadcrumbs mainTitle="Investor Earnings" parent="Dashboard" title="Earnings" />
            <Container fluid={true} className="pb-5">
                
                {/* STATS SECTION - SIDE BY SIDE */}
                <Row className="mb-4">
                    {/* Card 1: Total Commission */}
                    <Col xl="6" md="6" className="mb-3 mb-xl-0">
                        <Card className="border-0 shadow-sm" style={{ borderRadius: 15 }}>
                            <CardBody className="p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="bg-light-primary p-2 rounded-circle me-3">
                                        <i className="fa fa-money text-primary" style={{ fontSize: '20px' }} />
                                    </div>
                                    <H6 attrH6={{ className: 'mb-0', style: { color: COLORS.normal } }}>
                                        Total Commission Earned
                                    </H6>
                                </div>
                                <h2 className="fw-bold mb-0" style={{ color: COLORS.normal }}>
                                    <CountUp 
                                        start={0} 
                                        end={balance} 
                                        decimals={2} 
                                        prefix="₦ " 
                                        duration={2} 
                                    />
                                </h2>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* Card 2: Company Tax Liability (NTA 2025 Context) */}
                    <Col xl="6" md="6">
                        <Card className="border-0 shadow-sm" style={{ borderRadius: 15 }}>
                            <CardBody className="p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="bg-light-warning p-2 rounded-circle me-3">
                                         <i className="fa fa-money text-primary" style={{ fontSize: '20px' }} />
                                    </div>
                                    <H6 attrH6={{ className: 'mb-0', style: { color: COLORS.normal } }}>
                                        Current Interest Balance
                                    </H6>
                                </div>
                                <h2 className="fw-bold mb-0" style={{ color: COLORS.normal }}>
                                    <CountUp 
                                        start={0} 
                                        end={currentInterest} 
                                        decimals={2} 
                                        prefix="₦ " 
                                        duration={2} 
                                    />
                                </h2>
                              </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* TABLE SECTION */}
                <Row>
                    <Col sm="12">
                        <Card className="border-0 shadow-sm" style={{ borderRadius: '16px' }}>
                            <CardBody className="p-0">
                                {/* Table Header */}
                                <div className="p-4 d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                                    <div className="mb-3 mb-md-0">
                                        <H5 attrH5={{ className: 'mb-1 fw-bold text-dark' }}>Earning Analytics</H5>
                                        <p className="text-muted mb-0 f-12">
                                            Detailed breakdown of interest generated per investment
                                        </p>
                                    </div>
                                    <Button 
                                        className="btn-pill px-4 shadow-sm fw-bold" 
                                        color="warning" 
                                        onClick={toggle}
                                        style={{ 
                                            fontSize: '12px', 
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}
                                    >
                                        <i className="fa fa-send-o me-2" /> Transfer Funds
                                    </Button>
                                </div>
                                
                                {/* Table Content */}
                                <div className="px-3 pb-3">
                                    <EarnHistoryTable 
                                        data={data} 
                                        isLoading={isLoading}
                                        totalRows={totalRows}
                                        currentPage={currentPage}
                                        onPageChange={fetchHistory}
                                        limit={LIMIT}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <TransferModal modal={modal} toggle={toggle} />
            </Container>
        </Fragment>
    );
};

export default EarnInterest;